import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CONST_AWS_API, DEFAULT_IMAGE } from 'src/app/core/constants';
import { LandingPageService } from 'src/app/core/services/landing-page.service';
import { Subscription } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommanSubscribeService } from './../../../../core/services/comman-subscribe.service';
import { AppService } from 'src/app/core/services/app.service';
import { Title } from '@angular/platform-browser';
declare let ga: Function;

// Live/upcoming events and their recordings; parent and child streams share the event's slug.
const EVENT_TYPES = ['stream', 'recvideo', 'recvideoalbum'];

@Component({
  selector: 'app-ic-search',
  templateUrl: './ic-search.component.html',
  styleUrls: ['./ic-search.component.scss']
})
export class IcSearchComponent implements OnInit {
  @ViewChild('widgetsContent', { static: false }) widgetsContent: ElementRef;

  searchList: any = [];
  filterGenres = [];
  filterSubCategories = [];
  searchDataSubscription: Subscription;
  categorySubIcons = ['category', 'subCategory', 'genre'];
  isAppCallEnd = false;
  isShowSideFilter = false;
  searchInfo: any = {};
  searchKey: any;
  performerInfoSubscr: Subscription;
  channelName: any = "";
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  searchData: any = []
  routerevents: any;

  constructor(private router: Router, private _matDialog: MatDialog, private ngxLoader: NgxUiLoaderService,
    private activatedRoute: ActivatedRoute, private landingPageService: LandingPageService,
    private commanSubscribeService: CommanSubscribeService, private appService: AppService,private titleService: Title) {
      
  }

  ngOnInit() {


    if (this.activatedRoute.snapshot.params.channelName) {
      this.channelName = this.activatedRoute.snapshot.params.channelName;
    }
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
    })
    this.searchInfo = {
      searchKeyWords: this.activatedRoute.snapshot.queryParams.key,
      categoryId: this.activatedRoute.snapshot.queryParams.categoryId,
      categoryName: this.activatedRoute.snapshot.queryParams.categoryName
    };
    this.searchDataSubscription = this.landingPageService.getSearchData().subscribe(res => {
      this.searchInfo = {
        searchKeyWords: res.searchKeyWords,

      }
      this.selectedData['selectedArtistList'] = this.selectedData['selectedGenreList'] = this.selectedData['selectedModeList'] = [];
      this.filterSearchResult();
    });

    let perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
    this.performerInfoSubscr = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      this.getPerformerInfo(response);
    })
    if (Object.keys(perfomerInfoData).length > 0)
      this.getPerformerInfo(perfomerInfoData);
  }
  iconShow: boolean = false;
  openIcon() {
    this.iconShow = !this.iconShow
  }
  scrollLeft() {
    this.widgetsContent.nativeElement.scrollLeft -= 1250;
  }

  scrollRight() {
    this.widgetsContent.nativeElement.scrollLeft += 1250;
  }
  leftScroll(data, plan) {
    // this.divid = 'gener' + data;
    console.log('left')
    document.getElementById('gener' + data).scrollLeft -= 400;
    // if (document.getElementById('gener' + data).scrollLeft == 0) {
    //   this.generList.forEach(element => {
    //     if (element.id == plan.id) {
    //       element.lefthide = false;
    //     }
    //   });
    // }
    // else {
    //   this.generList.forEach(element => {
    //     if (element.id == plan.id) {
    //       element.lefthide = true;
    //     }
    //   });
    // }

  }
  rightScroll(data, plan) {
    // let scroll =  document.getElementById('gener'+data).scrollLeft += 30;
    console.log('right------')
    document.getElementById('gener' + data).scrollLeft += 400;
    // let scrollLeftPrev = scroll + 30;
    // if (document.getElementById('gener' + data).scrollLeft == 0) {
    //   this.generList.forEach(element => {
    //     if (element.id == plan.id) {
    //       element.lefthide = false;
    //     }
    //   });
    // }
    // if(Math.abs(document.getElementById('gener'+data).scrollWidth) < (document.getElementById('gener'+data).scrollLeft+Math.abs(document.getElementById('gener'+data).offsetWidth))){
    //   this.generList.forEach(element => {
    //     if (element.id == plan.id) {
    //       element.righthide = false;
    //     }
    //   });
    // }
    // else {
    //   this.generList.forEach(element => {
    //     if (element.id == plan.id) {
    //       element.lefthide = true;
    //     }
    //   });
    // }
    // console.log(document.getElementById('gener' + data).scrollLeft, Math.abs(document.getElementById('gener' + data).scrollWidth), (document.getElementById('gener' + data).scrollLeft + Math.abs(document.getElementById('gener' + data).offsetWidth)))
  }
  selectedData: any = {};
  changeVal(event, i, type) {
    this.selectedData['selectedArtistList'] = this.artistList;
    this.selectedData['selectedGenreList'] = this.genresList;
    this.selectedData['selectedModeList'] = this.streamPaymentModeList;
    if (type == 'artist') {
      this.artistList.forEach((e, index) => {
        if (index == i && event.checked) {
          e.isChecked = true;
          this.filterSearchResult('artist', e)
        } else if (index == i && !event.checked) {
          this.selectedVal.artist = '';
          this.filterSearchResult();
        }
      })
    }
    if (type == 'genre') {
      this.genresList.forEach((e, index) => {
        if (index == i && event.checked) {
          e.isChecked = true;
          this.filterSearchResult('genre', '', e)
        } else if (index == i && !event.checked) {
          this.selectedVal.genre = '';
          this.filterSearchResult();
        }
      })
    }
    if (type == 'mode') {
      this.streamPaymentModeList.forEach((e, index) => {
        if (index == i && event.checked) {
          e.isChecked = true;
          this.filterSearchResult('mode', '', '', e)
        } else if (index == i && !event.checked) {
          this.selectedVal.mode = '';
          this.filterSearchResult();
        }
      })
    }
  }

  audiosList = [];
  albumsList = [];
  videosList = [];
  videoAlbumList = [];
  eventsList = [];
  freeCount = [];
  subscriptionCount = [];
  selectedVal: any = {};
  noRec: boolean = false;
  searchUnavailable = false;
  pageSize = 20;
  pageSizeOptions: number[] = [20, 40, 60, 80, 100];
  start = 0;
  limit = 20;
  filterSearchResult(type?, artist?, genre?, mode?, event?) {
    if (event) {
      console.log(event);
      this.start = event.pageIndex * event.pageSize;
      this.limit = event.pageSize;
    } else {
      this.start = 0;
      this.limit = 20;
    }
    this.searchData = [];
    this.noRec = false;
    this.searchUnavailable = false;
    this.audiosList = [];
    this.albumsList = [];
    this.videosList = [];
    this.videoAlbumList = [];
    this.eventsList = [];
    let query = "", staticUrl = "";
    // this.selectedVal = {};
    this.artistList = [];
    this.genresList = [];
    this.streamPaymentModeList = [];
    if (this.searchInfo.searchKeyWords && this.searchInfo.searchKeyWords.trim()) {
      this.ngxLoader.start();
      this.isAppCallEnd = false;
      staticUrl = "?q=" + `${encodeURIComponent(this.searchInfo.searchKeyWords.trim())}` + "&performer_id=" + `${this.performer_details.user_id}` + "&start=" + `${this.start}` + "&limit=" + `${this.limit}`;
      if (type == undefined || type == 'all' || type == '') {
        query = staticUrl;
        if (type == 'all') {
          this.selectedData['selectedArtistList'] = this.selectedData['selectedGenreList'] = this.selectedData['selectedModeList'] = [];
          this.selectedVal.artist = this.selectedVal.genre = this.selectedVal.mode = '';
        }
      }
      if (type == 'artist') {
        query = staticUrl + "&artist=" + `${encodeURIComponent(artist.key)}`;
        this.selectedVal.artist = artist.key;
      } else if (type == 'genre') {
        this.selectedVal.genre = genre.key;
        query = staticUrl + "&genre=" + `${encodeURIComponent(this.selectedVal.genre)}`;
        if (this.selectedVal.mode)
          query = staticUrl + this.selectedVal && this.selectedVal.mode ? "&genre=" + `${encodeURIComponent(this.selectedVal.genre)}` + "&stream_payment_mode=" + `${encodeURIComponent(this.selectedVal.mode)}` : "&genre=" + `${encodeURIComponent(this.selectedVal.genre)}`;
      } else if (type == 'mode') {
        this.selectedVal.mode = mode.key;
        query = staticUrl + "&stream_payment_mode=" + `${encodeURIComponent(this.selectedVal.mode)}`;
      }
      if (this.selectedVal && type != 'all') {
        if (this.selectedVal.artist) {
          query = staticUrl + "&artist=" + `${encodeURIComponent(this.selectedVal.artist)}`;
        }
        if (this.selectedVal.genre) {
          query = staticUrl + "&genre=" + `${encodeURIComponent(this.selectedVal.genre)}`;
        }
        if (this.selectedVal.mode) {
          query = staticUrl + "&stream_payment_mode=" + `${encodeURIComponent(this.selectedVal.mode)}`;
        }
        if (this.selectedVal.artist && this.selectedVal.genre) {
          query = this.selectedVal && this.selectedVal.artist ? staticUrl + "&genre=" + `${encodeURIComponent(this.selectedVal.genre)}` + "&artist=" + `${encodeURIComponent(this.selectedVal.artist)}` : staticUrl + "&genre=" + `${encodeURIComponent(this.selectedVal.genre)}`;
        }
        if (this.selectedVal.artist && this.selectedVal.mode) {
          query = this.selectedVal.artist ? staticUrl + "&artist=" + `${encodeURIComponent(this.selectedVal.artist)}` + "&stream_payment_mode=" + `${encodeURIComponent(this.selectedVal.mode)}` : staticUrl + "&artist=" + `${encodeURIComponent(this.selectedVal.artist)}`;
        }
        if (this.selectedVal.genre && this.selectedVal.mode) {
          query = this.selectedVal.genre ? staticUrl + "&genre=" + `${encodeURIComponent(this.selectedVal.genre)}` + "&stream_payment_mode=" + `${encodeURIComponent(this.selectedVal.mode)}` : staticUrl + "&genre=" + `${encodeURIComponent(this.selectedVal.genre)}`;
        }
        if (this.selectedVal && this.selectedVal.artist && this.selectedVal.genre && this.selectedVal.mode) {
          query = staticUrl + "&genre=" + `${encodeURIComponent(this.selectedVal.genre)}` + "&artist=" + `${encodeURIComponent(this.selectedVal.artist)}` + "&stream_payment_mode=" + `${encodeURIComponent(this.selectedVal.mode)}`;
        }

      }
      let myInit = {
        headers: {
          'x-api-key': environment.AWS_Cognito.X_Api_Key
        },
        response: true,
      }
      this.searchList = [];
      if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id) {
        if (this.settingsData.channelInfo.channel_id != 0)
          query += `&channel_id=${this.settingsData.channelInfo.channel_id}`
      }
      API.get(environment.AWS_Cognito.apiName, CONST_AWS_API.SEARCH + query, myInit).then(response => {
        this.searchList = [];
        this.ngxLoader.stop();
        if (response.status == 200) {
          try { ga('set', 'page', this.router.url); ga('send', 'pageview'); } catch (e) { }
          response.data = response.data.body;
          if (response.data.hits.hits.length > 0) {
            this.noRec = false;
            this.filterRespCat(response);
          } else {
            this.selectedVal = {};
            this.noRec = true;
            this.commanSubscribeService.sendSearchKey('');
          }
        }
      }).catch(error => {
        this.ngxLoader.stop();
        this.noRec = true;
        this.searchUnavailable = true;
      });
      this.searchData = [];
      this.searchData = [
        { name: "Events", data: this.eventsList },
        { name: "Audios", data: this.audiosList },
        { name: "Albums", data: this.albumsList },
        { name: "Videos", data: this.videosList },
        { name: "Video Albums", data: this.videoAlbumList },
      ]
    } else {
      setTimeout(() => {
        this.router.navigate([this.commanSubscribeService.getChannelBasePath(this.channelName)]);
      }, 100);
    }
  }
  assets_url = environment.assets_url
  artistList = [];
  genresList: any = [];
  streamPaymentModeList = [];
  totalResp = 0;
  filterRespCat(response) {
    if (response.data.aggregations) {
      let facetsData = response.data.aggregations;
      if (facetsData.artist.buckets.length > 0) {
        this.artistList = facetsData.artist.buckets;
      }
      if (facetsData.genres.buckets.length > 0) {
        this.genresList = facetsData.genres.buckets;
      }
      if (facetsData.stream_payment_mode.buckets.length > 0) {
        this.streamPaymentModeList = facetsData.stream_payment_mode.buckets;
      }
    }
    this.totalResp = response.data.hits.total.value;
    response.data.hits.hits.forEach((e, i) => {
      let source = e._source;
      if (!source.pic)
        source.pic = this.assets_url + "album-cover.svg";
      if (source.type == 'audio')
        this.audiosList.push(source);
      if (source.type == "audioalbum")
        this.albumsList.push(source);
      if (source.type == "video")
        this.videosList.push(source);
      if (source.type == 'videoalbum')
        this.videoAlbumList.push(source);
      if (EVENT_TYPES.includes(source.type) && source.slug && !this.eventsList.some(item => item.slug == source.slug))
        this.eventsList.push(source);
    });
    this.noRec = !(this.eventsList.length || this.audiosList.length || this.albumsList.length || this.videosList.length || this.videoAlbumList.length);
    this.audiosList = [...new Set(this.audiosList)];
    this.albumsList = [...new Set(this.albumsList)];
    this.videosList = [...new Set(this.videosList)];
    this.videoAlbumList = [...new Set(this.videoAlbumList)];
    if (this.genresList.length > 0)
      this.genresList = this.genresList.flat();
    this.artistList = [...new Set(this.artistList)];
    this.genresList = [...new Set(this.genresList)];
    this.selectedData.selectedArtistList.forEach(element => {
      this.artistList.forEach(e => {
        if (element.isChecked && element.key == this.selectedVal.artist && e.key == this.selectedVal.artist)
          e.isChecked = element.isChecked;
      })
    });
    this.selectedData.selectedGenreList.forEach(element => {
      this.genresList.forEach(e => {
        if (element.isChecked && element.key == this.selectedVal.genre && e.key == this.selectedVal.genre)
          e.isChecked = element.isChecked;
      })
    });
    this.selectedData.selectedModeList.forEach(element => {
      this.streamPaymentModeList.forEach(e => {
        if (element.isChecked && element.key == this.selectedVal.mode && e.key == this.selectedVal.mode)
          e.isChecked = element.isChecked;
      })
    });
  }

  goToAlbum(data) {
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    if (EVENT_TYPES.includes(data.type)) {
      if (!this.settingsData.is_preview)
        this.router.navigate([base + "/event/" + data.slug]);
      return;
    }
    let type = data.type == 'audioalbum' ? 'audio' : data.type == 'videoalbum' ? 'video' : data.type;
    if (this.settingsData.is_preview) {
      this.commanSubscribeService.albumBackHistory = base + "/album/" + type + "/" + data.slug + "/preview";
      this.router.navigate([base + "/album/" + type + "/" + data.slug + "/preview"], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    } else {
      if (data.type == 'audioalbum' || data.type == 'videoalbum') {
        this.commanSubscribeService.albumBackHistory = base + "/album/" + type + "/" + data.id;
        this.router.navigate([base + "/album/" + type + "/" + data.slug]);
      } else {
        this.commanSubscribeService.albumBackHistory = base + "/album/" + type + "/" + data.id;
        this.router.navigate([base + "/album/" + type + "/" + data.slug], { queryParams: { id: data.id } });
      }
    }
  }

  goToGener(data) {
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    if (this.settingsData.is_preview) {
      this.router.navigate([base + "/" + data.tag_category + "/" + data.id + "/" + data.performer_id + "/preview"], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    } else {
      this.router.navigate([base + "/" + data.tag_category + "/" + data.id + "/" + data.performer_id]);
    }
  }


  org_info: any = {};
  performer_details: any = {};
  getPerformerInfo(response) {
    const info = response?.data?.statusCode === '200' ? response.data.Data?.[0] : null;
    // Without the network there is nothing to search; show "No records found" instead of a blank page.
    if (!info?.performer_details?.user_id) {
      this.noRec = true;
      return;
    }
    if (info.org_info) {
      this.org_info = info.org_info;
    }
    this.performer_details = info.performer_details;
    this.filterSearchResult();
  }

  goBack() {
    const ch = this.activatedRoute.snapshot.params.channelName;
    const base = this.commanSubscribeService.getChannelBasePath(ch);
    if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id && this.settingsData.channelInfo.channel_id != 0)
      this.router.navigate([base + '/channel/' + this.settingsData.channelInfo.channel_name])
    else
      this.router.navigate([base]);
  }

  ngOnDestroy() {
    if (this.performerInfoSubscr)
      this.performerInfoSubscr.unsubscribe();
    if (this.searchDataSubscription)
      this.searchDataSubscription.unsubscribe();
  }

}
